var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "social-schedule-calendar" },
    [
      _c(
        "b-modal",
        {
          staticClass: "modal-edit-social-deliverable",
          attrs: {
            size: "lg",
            "hide-footer": "",
            id: "editSocialModalCalendar",
            title: "Edit Social Deliverable",
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          },
          on: {
            show: _vm.editSocialModalShown,
            shown: _vm.afterEditSocialModalShown,
            hide: _vm.editSocialModalHidden,
            hidden: _vm.removeRoute
          }
        },
        [
          _c("EditSocialModal", {
            ref: "refEditSocialModal",
            attrs: {
              allContacts: _vm.allContacts,
              tabIndex: _vm.tabIndex,
              namespace: _vm.namespace
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "deliverable-header" }, [
        _vm.namespace == ""
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.dataLoading,
                    expression: "dataLoading"
                  }
                ],
                staticStyle: {
                  left: "50%",
                  border: "none",
                  background: "transparent",
                  "z-index": "9000"
                },
                attrs: { id: "global-spinner-inline" }
              },
              [_c("b-spinner", { attrs: { label: "Loading" } })],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "header-title-tabs-row" },
          [
            !_vm.namespace
              ? _c("HeaderIcon", {
                  attrs: {
                    totalDeliverableCount: this.allDeliverablesPaginationData
                      .total
                      ? this.allDeliverablesPaginationData.total
                      : 0,
                    totalOutletCount: this.outletCount ? this.outletCount : 0,
                    myWeek: false,
                    namespace: _vm.namespace
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.namespace
              ? _c("SocialTabs", { attrs: { namespace: _vm.namespace } })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _vm.namespace != ""
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.dataLoading,
                    expression: "dataLoading"
                  }
                ],
                staticStyle: {
                  left: "50%",
                  border: "none",
                  background: "transparent",
                  "z-index": "9000"
                },
                attrs: { id: "global-spinner-above-list" }
              },
              [_c("b-spinner", { attrs: { label: "Loading" } })],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "calendar-container",
          attrs: {
            id: "socialScheduleCalendarContainer" + _vm.parentDeliverableId
          }
        },
        [
          _c("div", {
            key: "social-calender-ref-" + _vm.parentDeliverableId,
            ref: "SchedulerComponent",
            staticClass: "calendar"
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }